import type { ComponentPropsWithRef, ReactNode } from 'react';

import { cn } from '@core/utils/cn';

import { Surface, type SurfaceProps } from './Surface';

export interface CardProps extends SurfaceProps {}

export function Card({ className, ...props }: CardProps) {
  return <Surface className={cn('p-5', className)} {...props} />;
}

// `title` is omitted from the div props: the HTML title attribute is `string`, and
// leaving both in scope makes a ReactNode heading a type error.
export interface CardHeaderProps extends Omit<ComponentPropsWithRef<'div'>, 'title'> {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}

export function CardHeader({ title, description, actions, className, ...props }: CardHeaderProps) {
  return (
    <div className={cn('mb-4 flex items-start gap-3', className)} {...props}>
      <div className="min-w-0 flex-1">
        <h3 className="text-[17px] font-semibold tracking-[-0.01em]">{title}</h3>
        {description && <p className="text-fg-muted mt-0.5 text-[13px]">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
